import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'

const Wrapper = styled.div`
  padding: 0;
  margin: 0;
  position: relative;
  width: 100vw;
  height: 100vh;
  background: ${`url('/assets/background/background` +
    (Math.round(Math.random() * 10) + 1) +
    `.jpg')`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
`

const LogInput = styled.input`
  height: 30px;
  max-width: 300px;
  font-size: 15px;
  position: relative;
  border-radius: 5px;
  padding: 5px 15px;
  margin-top: 15px;
  color: ${({ emailError }) =>
    emailError ? 'rgb(222, 99, 99)' : 'rgb(89, 89, 89)'};
  outline: none;
  border: ${({ emailError }) =>
    emailError ? '1px solid rgb(222, 99, 99)' : 'none'};
`

const Submit = styled.button`
  max-width: 330px;
  height: 40px;
  min-height: 40px;
  font-size: 15px;
  border-radius: 5px;
  background: rgb(70, 144, 255);
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  margin-top: 15px;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:active {
    background-color: rgb(51, 107, 190);
    color: rgb(191, 191, 191);
  }
`

const InputError = styled.div`
  ${'' /* margin: -23px 0 0 0; */} color: rgb(218, 33, 33);
  font-size: 13px;
  ${'' /* position: absolute; */};
`

const LogWrapper = styled.div`
  width: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? 'calc(100vw - 50px)' : '500px'};
  ${'' /* height: 550px; */} display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: absolute;
  padding: 25px;
  background: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone'
      ? 'rgba(255, 255, 255, 0.53)'
      : 'rgba(255, 255, 255, 0.83)'};
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.51);
  ${'' /* border-radius: 5px; */} left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`

const CenterBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const Back = styled.div`
  padding: 15px 0 0 0;
  color: rgb(52, 51, 51);
  text-decoration: underline;
  font-size: 15px;
  cursor: pointer;
`

const Logo = styled.img`
  width: 70%;
  height: 100%;
`

const Message = styled.div`
  ${'' /* width: 500px; */} ${'' /* background: rgba(240, 209, 132, 0.58); */} border-radius: 5px;
  font-weight: lighter;
  padding: 25px;
  color: rgb(52, 51, 51);
  text-align: center;
  font-size: 25px;
`

const ResetMessage = styled.div`
  ${'' /* background: rgba(240, 209, 132, 0.58); */} border-radius: 5px;
  font-weight: lighter;
  padding: 10px;
  color: rgb(52, 51, 51);
  text-align: justify;
  font-size: 15px;
`

const FooterMessage = styled.div`
  width: calc(100% - 50px);
  font-size: 12px;
  text-align: center;
  ${'' /* position: absolute;
  bottom: 2%; */} color: rgb(52, 51, 51);
  padding: 0 25px;
  margin-top: 15px;
`

const Big = styled.span`
  font-weight: bold;
`

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailError: false,
      resetPassword: false
    }
  }

  handleEnter = e => {
    if (e.charCode === 13) {
      this.handleSubmit()
    }
  }

  handleSubmit = () => {
    if (
      this.props.email.match(
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      )
    ) {
      this.setState({
        emailError: false
      })
      this.props.submit()
    } else {
      this.setState({
        emailError: true
      })
    }
  }

  sendResetPassword = () => {
    if (
      this.props.email.match(
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      )
    ) {
      this.props.handleResetPassword()
      this.setState({
        emailError: false
      })
    } else {
      this.setState({
        emailError: true
      })
    }
  }

  toggleResetPassword = () => {
    this.setState({
      resetPassword: !this.state.resetPassword
    })
  }

  render() {
    return (
      <Wrapper>
        <LogWrapper mediaQuery={this.props.mediaQuery}>
          <a
            onClick={() => window.open('http://www.afja-asso.fr/', '_blank')}
            style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            <Logo alt="AFJA" src="/assets/logo/logo.png" />
          </a>
          <CenterBox>
            <Message>Bienvenue sur notre annuaire !</Message>
            {this.state.resetPassword ? (
              <ResetMessage>
                Pour créer ou réinitialiser votre mot de passe :
                <br />
                1/ Entrer votre email
                <br />
                2/ Cliquer sur « envoyer »
                <br />
                3/ Vous allez recevoir un email de confirmation
              </ResetMessage>
            ) : (
              ''
            )}

            <LogInput
              placeholder="Email"
              type="email"
              name="email"
              input={this.state.email}
              onChange={this.props.handleChange}
              emailError={this.state.emailError}
              value={this.props.user.email}
              onKeyPress={this.handleEnter}
              mediaQuery={this.props.mediaQuery}
            />
            {this.state.resetPassword ? (
              ''
            ) : (
              <LogInput
                type="password"
                placeholder="Password"
                name="password"
                onChange={this.props.handleChange}
                value={this.props.user.password}
                onKeyPress={this.handleEnter}
                mediaQuery={this.props.mediaQuery}
              />
            )}
            <Submit
              onClick={
                this.state.resetPassword
                  ? this.sendResetPassword
                  : this.handleSubmit
              }
              mediaQuery={this.props.mediaQuery}
            >
              {this.state.resetPassword ? 'Envoyer' : 'Se connecter'}
            </Submit>
            {this.state.resetPassword ? (
              <Back onClick={this.toggleResetPassword}>Connexion</Back>
            ) : (
              [
                <Back onClick={this.toggleResetPassword}>
                  Première visite{' '}
                </Back>,
                <Back onClick={this.toggleResetPassword}>
                  Mot de passe oublié{' '}
                </Back>
              ]
            )}
          </CenterBox>
          <FooterMessage>
            <Big>
              Abonnement à l’annuaire AFJA au{' '}
              <a href="tel:+33142469048">0142469048</a> -{' '}
              <a href="mailto:contact@afja-asso.fr">contact@afja-asso.fr</a>
            </Big>
            {/* <br />
              <a href="http://www.afja-asso.fr/">http://www.afja-asso.fr/</a>
              <br />
              AFJA - Association des journalistes de l’agriculture et de
              l’alimentation
              <br />
              9 rue papillon, 75009 Paris <br />
              <a href="http://www.afja-asso.fr">www.afja-asso.fr</a> - Twitter :{' '}
            <a href="https://twitter.com/@afja1">@afja1</a> */}
          </FooterMessage>
        </LogWrapper>
      </Wrapper>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/login/index.js